<div fxFlex="100" class="inputs" fxLayout="row wrap">
    <!-- Region Name -->
    <!-- <div class="m1em" fxFlex="12em" fxLayout="row"> -->
    <app-edit-suggestion-field [isEditable]="true" [label]="'Region Name*'" [name]="'region_name'"
        [(ngModel)]="regionObject.name" (onSelect)="editRegionMaster($event)"
        [listUrl]="region_url+'region/?name=::search::'" displayField="name" class="m1em" fxFlex="12em" fxFlex.xs="10em"
        fxLayout="column" [errors]="errorObj.name">
    </app-edit-suggestion-field>
    <!-- </div> -->

    <!-- Description -->
    <!-- <div class="ai-fxs m1em " fxFlex="12em" fxLayout="row"> -->
    <app-text-field fxFlex="12em" [isMultiline]="true" [isEditable]="true" [label]="'Description'"
        [(ngModel)]="regionObject.description" [name]="'description'" class="ai-fxs m1em " fxFlex="12em" fxFlex.xs="10em"
        fxLayout="column" [errors]="errorObj.description">
    </app-text-field>
    <!-- </div> -->

    <!-- List of Countries -->
    <!-- <app-mat-auto-search fxFlex="26.4em" [isEditable]="true" [multiple]="true" [label]="'Countries included*'"
        [name]="'countries'" [(ngModel)]="regionObject.countries" [setSearchValue]="false"
        [listUrl]="region_url+'region_country/?name=::search::'" [displayField]="'name'" [idField]="null"
        [errors]="errorObj.countries">
    </app-mat-auto-search> -->

    <app-select-field fxFlex="26.4em" fxFlex.xs="100" [isEditable]="true" [label]="'Countries included*'"
        [(ngModel)]="regionObject.countries" [name]="'countries'" [multiple]="true" [searchable]="true"
        [displayField]="'name'" [idField]="null" [options]="countryList?.results" [errors]="errorObj.countries">
    </app-select-field>

    <!-- Continent logo -->
    <div class="m1em countriesInput" fxFlex="26.4em" fxFlex.xs="100" fxLayout="row wrap">
        <div fxFlex="100" class="inputTitle">
            <span>Pick an icon</span>
        </div>
        <div fxFlex="100" fxLayout="row wrap">
            <mat-radio-group [(ngModel)]="regionObject.logo_id" fxFlex="100" class="iconBox">
                <mat-radio-button class="icon" *ngFor="let continent of continents" [value]="continent">
                    <img src="/assets/images/icons/geography/{{continent}}.svg">
                </mat-radio-button>
            </mat-radio-group>
        </div>
    </div>
    <div class="ai-fxs m1em" fxFlex="26.4em" fxFlex.xs="100"  fxLayout="column">
        <section>
            <mat-checkbox color="primary" [(ngModel)]="regionObject.is_active" checked>Active
            </mat-checkbox>
        </section>
    </div>
    <div class="btnb">
        <!-- <button class="bck" mat-stroked-button (click)="closeDD()">Cancel</button> -->
        <button mat-stroked-button class="nxt" (click)="onRegionSave()">Save</button>
    </div>
</div>